import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { ContentService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { documentToPlainTextString } from '@contentful/rich-text-plain-text-renderer';


// animations inspired by: 
// https://www.youtube.com/watch?v=HSxQbGXDo3U&ab_channel=BrianTreese
// https://stackblitz.com/edit/stackblitz-starters-3ufzct?file=src%2Fsign-up-form%2Fsign-up-form.component.ts

@Component({
  selector: 'lcp-services',
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss'],
  // animations: [
  //   trigger('activeServiceChange', [
  //     transition('* => *', [
  //       query(':self', [
  //         style({height: '{{startHeight}}px'})
  //       ]),
  //       query(':enter', [
  //         style({opacity: 0, scale: 0.9})
  //       ], { optional: true }),
  //       query(':leave', [
  //         style({opacity: 1, scale: 1, height: '*'}),
  //         animate('1ms ease-in', style({opacity: 0, scale: 0.5, height: '{{startHeight}}px'}))
  //       ], { optional: true }),
  //       group([
  //         query(':self', [
  //           animate('500ms ease-in', style({height: '*'}))
  //         ]),
  //         query(':enter', [
  //           animate('500ms ease-in', style({opacity: 1, scale: 1}))
  //         ], { optional: true }),
  //       ], { params: { startHeight: 0 } })
  //     ])
  //   ])
  // ]
})
export class ServicesComponent implements OnInit, AfterViewInit, OnDestroy {


  // @ViewChild('aboutServicesSection') aboutServicesSection: ElementRef

  slug = 'services'
  content: any
  fields: any

  route$: any
  fragment$: any
  fragment: string
  // defaultService = 'marketing_outreach'
  hoveringServiceIndex: number
  mobileTypedServiceIndices: number[] = []

  // activeService: string
  // protected activeService = signal<string>(this.defaultService)

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public contentService: ContentService,
    public lcpHelper: LcpHelper
  ) { }

  ngOnInit(): void {
    // console.log('activeService', this.activeService())
    this.getPage()
    this.route$ = this.routeStream()
    this.fragment$ = this.fragmentStream()
  }

  ngAfterViewInit(): void {
    // this.initIntersectionObservers()
    // if(!this.fragment) return
    // switch (this.fragment) {
    //   case this.defaultService: {
    //     window.setTimeout(() => {
    //       // console.log('services!', this.aboutServicesSection)
    //       // this.aboutServicesSection.nativeElement.scrollIntoView();
    //       try {
    //         document.getElementsByClassName('lcp-about-services')[0].scrollIntoView()
    //       } catch {
    //         console.log('ERR:lcp-about-services')
    //       }
    //     }, 500)
    //   }
    // }
  }

  ngOnDestroy(): void {
    if (this.fragment$) this.fragment$.unsubscribe()
    if (this.route$) this.route$.unsubscribe()
  }

  initIntersectionObservers() {
    const mobileWrappers = document.getElementsByClassName('service-wrapper-mobile')
    if (!mobileWrappers) return console.log('!mobileWrappers')
    const mobileWrappersArray = Array.prototype.slice.call( mobileWrappers )

    for (const [i, el] of mobileWrappersArray.entries()) {
    // mobileWrappersArray.forEach(el => {
      
      const mobileServiceElements = el.getElementsByClassName('services-service')
      this.initIntersectionObserver(mobileServiceElements[0], i)
    }
    // const mobileServiceElements = mobileWrappers.getElementsByClassName('services-service')
    // console.log('TODO: initIntersection', mobileServiceElements)
  }
  initIntersectionObserver(el: any, i: number) {
    const observer = new IntersectionObserver( 
      ([e]) => {
        if (this.mobileTypedServiceIndices.includes(i)) return 
        if (e.intersectionRatio < 0.05) return
        this.mobileTypedServiceIndices.push(i)
        // console.log('TODO: type mobile', i, e.target)
        const descriptionElement = e.target.querySelector('.services-service-description-text')
        const block = this.fields['sections'][0].fields['items'][i]
        // console.log('TODO: type mobile', i, this.fields)
        const params = { block: block }
        this.typeDescription(descriptionElement, params)

        // const descriptionElement =
        // this.typeDescription(el)


        // let lottie = el.getLottie()
        // let frame = Math.floor(e.intersectionRatio * (el.getLottie().totalFrames - 1))
        // let lottie = this.getLottieFromIndex(index)
        // if (!lottie) return console.log('ERR: initIntersectionObserver !lottie')

        // let frame = Math.floor(e.intersectionRatio * (this.getLottieFromIndex(index).totalFrames - 1))

        // DEBUGGING (keep)
        // if (Array.from(el.classList).indexOf('lottie-player_1_0') > -1) {
        //   console.log('IR:', el.id, e.intersectionRatio, frame)
        // }
        
        // el.seek(frame)
      },

      // ([e]) => e.target.classList.toggle('is-sticky', e.intersectionRatio < 1), 
      { rootMargin: '300px 0px -200px 0px',
        threshold: this.lcpHelper.percentageSequence(500) }
    );

    // console.log('scroll-inter', el)
    observer.observe(el)
  }

  // setActiveService(service: string) {
  //   this.activeService.set(service);
  // }

  // initLinkHandler() {
  //   // console.log('ilh')
  //   let els = document.getElementsByClassName('lcp-embedded-link')
  //   var arr = Array.prototype.slice.call( els )
  //   // console.log('arr', els, arr)
  //   for (let [i, el] of arr.entries()) {
  //     let slug = el.dataset['slug']
  //     if (slug === 'how-we-practice') {
  //       el.addEventListener("click", () => {
  //         this.displayProcess = !this.displayProcess;
  //         this.displayProcess ? el.classList.add('is-active') : el.classList.remove('is-active')
  //       });
  //     }
  //   }
  // }
  
  fragmentStream() {
    return this.route.fragment.subscribe(fragment => { 
      this.fragment = fragment // || 'print' 
    })
  }

  routeStream() {
    return this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        // console.log('navEnd', val)
        // this.updatePath()
        this.update()
      }
    })
  }

  update() {
    this.fragment = this.route.snapshot.fragment as string

    // this.setActiveService(this.fragment || this.defaultService)
    // console.log('fragment', this.fragment)

    // update embedded link 'is-active'
    let els = document.getElementsByClassName('lcp-embedded-link')
    var arr = Array.prototype.slice.call( els )
    // console.log('arr', els, arr)
    for (let [i, el] of arr.entries()) {
      // console.log('el', el) // this.fragment, el.getAttribute('href'))
      if (!this.fragment && i == 0) {
        el.classList.add('is-active')
        continue
      } else if (window.location.href != el.getAttribute('href')) {
        el.classList.remove('is-active')
        continue
      }
      el.classList.add('is-active')
      // console.log('match!', el)
    }
  }

  getPage(){
    // this.contentService.getPage({'fields.slug': 'home', 'fields.version': 2 })
    this.contentService.getPage({ 'fields.slug': this.slug })
    .subscribe({
      next: (content) => {
        this.content = content
        if (!this.content) return console.log('!content', this.content)
        // console.log('ci0', this.slug, this.content.items, this.content.items[0]);
        this.fields = this.content.items[0].fields
        // console.log('fields', this.fields)
        // console.log('fields, aboutServices', this.fields, this.aboutServices);
        window.setTimeout(() => {
          // this.initLinkHandler()
          this.initIntersectionObservers()

          this.update()
        }, 500)
      }
    });
  }

  serviceServiceElementDesktopFromIndex(index){
    return document.getElementById('services-service-desktop-' + index)
  }
  serviceDescriptionElementDesktopFromIndex(index: number) {
    // const container = document.querySelector('.service-wrapper-desktop .services-service-' + index)
    const container = this.serviceServiceElementDesktopFromIndex(index)
    return container && container.querySelector('.services-service-description-text')
  }
  serviceLinkFromBlock(block: any) {
    // console.log('TODO: serviceLinkFromBlock', block)
    const text = block.fields['linkText']
    const address = block.fields['linkAddress']
    if (!text || !address) return
    return {
      text: text,
      address: address
    }
    // const container = this.serviceServiceElementDesktopFromIndex(index)
    // return container && container.querySelector('.services-service-description')
  }

  // updateActiveService() {
  //   let sections = this.fields['sections']
  //   let servicesSection = sections.find((section:any) => section.fields['slug'] == 'about-services')
  //   // console.log('UAS', servicesSection.fields['items'])
  //   // this.defaultService = this.fields['sections'].fields
  // }

  async handleHoverService(params={}) {
    if (this.hoveringServiceIndex == params['index']) return // console.log('isHoveringServiceIndex', this.hoveringServiceIndex, params['index'])
    this.hoveringServiceIndex = params['index']
    const descriptionElement = this.serviceDescriptionElementDesktopFromIndex(params['index'])
    if (!descriptionElement) return console.log('ERR: !descriptionElement')

    this.lcpHelper.stopTypingElement(descriptionElement)
    
    window.setTimeout(this.typeDescription.bind(this, descriptionElement, params), 100)
    // window.setTimeout(() => { 
    //   this.lcpHelper.stopAllTyping = false 
    //   const block = params['block']
    //   // const container = elements && elements[0]
    //   // const descriptionElement = this.serviceDescriptionElementDesktopFromIndex(params['index'])
    //   if (descriptionElement.classList.contains('is-typed')) return
    //   descriptionElement.classList.add('is-typed')
    //   // const htmlElement = descriptionElement as HTMLElement
    //   // htmlElement.focus()
    //   this.serviceServiceElementDesktopFromIndex(params['index']).focus()
    //   // console.log('')

    //   descriptionElement.innerHTML = null

    //   const plainText = documentToPlainTextString(block.fields['body'])
    //   const typeParams = Object.assign({}, params, { shouldType: true, delay: 10, minDelay: 1 })

    //   // console.log('TODO: handleHoverService', plainText, descriptionElement)
    //   this.lcpHelper.isTypingElements.push(descriptionElement)
    //   this.lcpHelper.typeSentence(plainText, descriptionElement, typeParams)
    // }, 100)

    // const block = params['block']
    // // const container = elements && elements[0]
    // const descriptionElement = this.serviceDescriptionElementDesktopFromIndex(params['index'])
    // if (descriptionElement.classList.contains('is-typed')) return
    // descriptionElement.classList.add('is-typed')
    // descriptionElement.innerHTML = null

    // const plainText = documentToPlainTextString(block.fields['body'])
    // const typeParams = Object.assign({}, params, { shouldType: true, delay: 10 })

    // // console.log('TODO: handleHoverService', plainText, descriptionElement)
    // this.lcpHelper.typeSentence(plainText, descriptionElement, typeParams)
        // await this.lcpHelper.typeSentence(heroMessages[0].fields['text'], this.heroMessageLine1, Object.assign({}, params, { delay: 80 }))
  } 

  async typeDescription(el: Element, params={}) {
    this.lcpHelper.stopAllTyping = false 
    const block = params['block']
    // const container = elements && elements[0]
    // const descriptionElement = this.serviceDescriptionElementDesktopFromIndex(params['index'])
    if (el.classList.contains('is-typed')) return
    el.classList.add('is-typed')
    el.closest('.services-service-description-container').classList.add('is-typed')

    const cursorContainer = el.parentElement.querySelector('.services-service-cursor-container') 
    cursorContainer.classList.remove('opacity-0')

    // const htmlElement = el as HTMLElement
    // htmlElement.focus()
    // this.serviceServiceElementDesktopFromIndex(params['index']).focus()
    // console.log('')

    el.innerHTML = null

    const plainText = documentToPlainTextString(block.fields['body'])
    const typeParams = Object.assign({}, params, { shouldType: true, delay: 10, minDelay: 1 })

    // console.log('TODO: handleHoverService', plainText, el)
    this.lcpHelper.isTypingElements.push(el)
    await this.lcpHelper.typeSentence(plainText, el, typeParams)
    if (!this.lcpHelper.isTypingElements.includes(el)) return
    const link = this.serviceLinkFromBlock(params['block'])
    if (link) {
      el.insertAdjacentHTML('beforeend', ` `)
      let a = document.createElement('a');
      a.href =  link.address; // Insted of calling setAttribute 
      a.innerHTML = link.text
      el.appendChild(a)
      // el.insertAdjacentHTML('beforeend', `<a href=${link.address}>${link.text}</a>`)
    }
    
    // services-service-cursor-container
    cursorContainer.classList.add('opacity-0')
    // console.log('TODO: HIDE CURSOR', cursorContainer)

    // await this.lcpHelper.typeSentence()
  }



  handleBlurService(params={}) {
    // this.hoveringServiceIndex = null

    window.setTimeout(() => { if (this.hoveringServiceIndex == params['index']) this.hoveringServiceIndex = null }, 1)

    const descriptionElement = this.serviceDescriptionElementDesktopFromIndex(params['index'])
    if (!descriptionElement) return console.log('ERR: !descriptionElement')
    
    this.lcpHelper.stopTypingElement(descriptionElement)
    descriptionElement.classList.remove('is-typed')
    descriptionElement.innerHTML = null
    // console.log('TODO: handleBlurService', params)
  }

  handleSelectService(block) {
    // console.log('TODO: handleSelectService', block)
    const link = this.serviceLinkFromBlock(block)
    if (!link) return
    this.router.navigate([link])
  }

  // isActiveAboutService(service: any) {
  //   // fragment == service
  //   // console.log('CHECK', this.activeService(), service.fields?.slug.split('about-services--')[1])
  //   return this.activeService() == service.fields?.slug.split('about-services--')[1]
  // }
}
